import React from 'react';

export const CoralSvg = () => {
  return (
    <svg
      width="96"
      height="31"
      viewBox="0 0 96 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.8356 6.10218C24.5259 7.19844 23.2154 8.29557 21.8714 9.42005C19.7689 7.13758 17.1849 5.99194 14.0991 6.1745C11.5583 6.32443 9.3968 7.38188 7.68766 9.271C4.46782 12.8296 4.40873 18.0551 7.46101 21.6923C10.5406 25.362 16.3374 26.4283 20.7813 22.8829C21.9031 24.1846 23.0258 25.4873 24.1485 26.7899C18.8508 31.4651 9.48058 31.8461 3.66881 25.2721C-1.86252 19.0165 -1.05204 9.42534 5.51023 4.18308C12.2251 -1.18177 21.3272 0.586522 25.8356 6.10218Z"
        fill="white"
      />
      <path
        d="M86.7328 30.1294C85.0775 30.1294 83.5094 30.1294 81.8982 30.1294C81.8126 29.6444 81.8682 29.1637 81.8585 28.6884C81.8488 28.2068 81.8567 27.7244 81.8567 27.1864C81.7686 27.2508 81.7139 27.2737 81.6857 27.3143C80.6768 28.7545 79.2428 29.58 77.5918 30.0333C74.0836 30.9964 70.0074 29.6214 67.8688 26.1563C66.934 24.6429 66.4419 22.9972 66.2629 21.2351C66.0909 19.5409 66.2558 17.8916 66.9005 16.3209C68.3362 12.8213 70.9105 10.613 74.648 9.9277C78.3459 9.24949 81.5304 10.3457 84.0968 13.0939C85.5149 14.6126 86.3412 16.4417 86.6287 18.501C86.6949 18.9773 86.7284 19.4624 86.7302 19.9439C86.739 23.1674 86.7346 26.3909 86.7346 29.6144C86.7328 29.7714 86.7328 29.9284 86.7328 30.1294ZM76.411 25.5019C79.1511 25.5434 81.9017 23.4117 81.922 20.0515C81.9414 16.8218 79.3327 14.6443 76.5785 14.5649C73.6753 14.4812 70.9855 16.8024 70.9528 19.9951C70.922 23.0192 73.3887 25.4896 76.411 25.5019Z"
        fill="white"
      />
      <path
        d="M26.2587 20.0049C26.2075 14.4142 30.8525 9.71173 36.6176 9.73642C42.2168 9.76024 46.9694 14.3313 46.8838 20.1998C46.8001 25.9421 42.0148 30.4338 36.3777 30.3359C30.8499 30.2398 26.1846 25.6784 26.2587 20.0049ZM31.1004 20.0454C31.0219 22.8844 33.4436 25.5011 36.5391 25.5064C39.564 25.5117 42.0536 23.0687 42.0484 20.0516C42.0431 16.8616 39.4009 14.5695 36.5682 14.5624C33.5697 14.5554 31.0033 17.1297 31.1004 20.0454Z"
        fill="white"
      />
      <path
        d="M90.7089 1.08594C92.4348 1.08594 94.1298 1.08594 95.8566 1.08594C95.8566 10.7679 95.8566 20.4269 95.8566 30.1177C94.1457 30.1177 92.4515 30.1177 90.76 30.1177C90.7459 30.1045 90.7336 30.0956 90.7239 30.0842C90.7151 30.0736 90.7036 30.0612 90.7009 30.0489C90.6904 29.9916 90.6745 29.9342 90.6745 29.8769C90.6736 20.3555 90.6736 10.834 90.6745 1.3126C90.6745 1.25527 90.6912 1.19794 90.7089 1.08594Z"
        fill="white"
      />
      <path
        d="M50.4577 10.2324C52.1959 10.2324 53.9059 10.2324 55.608 10.2324C55.7033 10.6028 55.7156 29.5884 55.6213 30.0417C53.9174 30.0417 52.2065 30.0417 50.4974 30.0417C50.4065 29.7216 50.3669 11.0879 50.4577 10.2324Z"
        fill="white"
      />
      <path
        d="M57.6292 13.4608C57.5613 11.4915 59.2722 9.72405 61.3755 9.73639C63.1217 9.74609 65.0804 11.0761 65.091 13.4617C65.1007 15.6816 63.3607 17.2073 61.3526 17.2047C59.0596 17.202 57.5613 15.3182 57.6292 13.4608Z"
        fill="white"
      />
    </svg>
  );
};
